import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=5ff82f30&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff82f30')) {
      api.createRecord('5ff82f30', component.options)
    } else {
      api.reload('5ff82f30', component.options)
    }
    module.hot.accept("./Item.vue?vue&type=template&id=5ff82f30&", function () {
      api.rerender('5ff82f30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/v3/components/SnackBar/Item.vue"
export default component.exports